import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const healthCheckerApi = createApi({
    reducerPath: 'healthCheckerApi',
    baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL  }),
    endpoints: (builder) => ({
        // GET query
        getHealthCheckerQuiz: builder.query({
            query: () => ({
                url: '/api/healthchecker-data-list',
                method: 'GET',
            }),
        }),
    }),
});

// Export hooks for usage in components
export const {
    useGetHealthCheckerQuizQuery
} = healthCheckerApi;
